"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewPhysicalGateway extends new_item_1.default {
    constructor(newPhysicalGateway) {
        super();
        this.resetOwners = newPhysicalGateway.resetOwners;
        this.serialNumber = newPhysicalGateway.serialNumber;
        this.installationCode = newPhysicalGateway.installationCode;
        this.owners = newPhysicalGateway.owners;
    }
}
exports.default = NewPhysicalGateway;
//# sourceMappingURL=new-physicalGateway.js.map